export interface IButtonItem {
  label: string
  value: any
  disabled?: boolean
}
